/**
 * Credit pack definitions - single source of truth shared by the public
 * Pricing page and the in-app Buy Credits modal. `id` maps to the Stripe
 * pack id used by createCreditCheckoutSession.
 */
export const REPORT_PACKS = [
  { id: "reports_5",   amount: 5,   price: "CA$3.49",  perCredit: "70¢", label: "Quick top-up",          desc: "A few extra students covered" },
  { id: "reports_30",  amount: 30,  price: "CA$11.99", perCredit: "40¢", label: "One Report Folder", desc: "Enough for a typical Report Folder of students" },
  { id: "reports_60",  amount: 60,  price: "CA$17.99", perCredit: "30¢", label: "Two Report Folders",     desc: "Great for split-grade or two homerooms" },
  { id: "reports_120", amount: 120, price: "CA$22.99", perCredit: "19¢", label: "A full year",            desc: "A year's worth of reports at the lowest rate", best: true },
];

export const AI_PACKS = [
  { id: "ai_25",  amount: 25,  price: "CA$1.99",  perCredit: "8¢", label: "Light use",             desc: "Selective AI for your trickiest comments" },
  { id: "ai_100", amount: 100, price: "CA$5.99",  perCredit: "6¢", label: "Occasional use", desc: "AI comments for every student in a Report Folder" },
  { id: "ai_200", amount: 200, price: "CA$9.99",  perCredit: "5¢", label: "Heavy use",             desc: "AI across multiple Report Folders or report periods" },
  { id: "ai_500", amount: 500, price: "CA$19.99", perCredit: "4¢", label: "AI-powered",            desc: "Let AI draft every comment, all year long", best: true },
];
